import firebase from 'firebase'

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyBCrlBEN1NPfRCnXvIy4CEOerLLutE8GoQ",
    authDomain: "facebook-messenger-b37ea.firebaseapp.com",
    projectId: "facebook-messenger-b37ea",
    storageBucket: "facebook-messenger-b37ea.appspot.com",
    messagingSenderId: "492623689693",
    appId: "1:492623689693:web:9bf18b7feed6272612a834",
    measurementId: "G-EET70M2M17"
})

const db = firebaseApp.firestore()

export default db

